import cn from 'classnames';
import React, { useCallback } from 'react';

import isSwitchingToCMYK from 'editor/src/store/app/selector/isSwitchingToCMYK';
import setDesignColorSpaceOperation from 'editor/src/store/design/operation/setDesignColorSpaceOperation';
import getDesignColorSpace from 'editor/src/store/design/selector/getDesignColorSpace';
import { ColorSpace } from 'editor/src/store/design/types';
import { useDispatch, useSelector } from 'editor/src/store/hooks';

import IconLoading from 'editor/src/component/Icon/IconLoading';

import styles from './index.module.scss';

function ColorSpaceToggle() {
  const dispatch = useDispatch();
  const designColorSpace = useSelector(getDesignColorSpace) ?? ColorSpace.sRGB;
  const switchingToCMYK = useSelector(isSwitchingToCMYK);
  // A CMYK switch waiting for the print profile shows as chosen, which leaves sRGB clickable to cancel it.
  const colorSpace = switchingToCMYK ? ColorSpace.CMYK : designColorSpace;

  // Always dispatched: a click on the current colour space still cancels a CMYK switch that is
  // waiting for the print profile, and the operation skips the redundant switch itself.
  const onSelectSRGB = useCallback(() => {
    void dispatch(setDesignColorSpaceOperation(ColorSpace.sRGB));
  }, [dispatch]);

  const onSelectCMYK = useCallback(() => {
    void dispatch(setDesignColorSpaceOperation(ColorSpace.CMYK));
  }, [dispatch]);

  return (
    <div className={cn(styles.container, 'cy-color-space-toggle')}>
      <button
        type="button"
        className={cn(styles.button, { [styles.active]: colorSpace === ColorSpace.sRGB }, 'cy-color-space-toggle-srgb')}
        onClick={onSelectSRGB}
      >
        sRGB
      </button>
      <button
        type="button"
        className={cn(styles.button, { [styles.active]: colorSpace === ColorSpace.CMYK }, 'cy-color-space-toggle-cmyk')}
        onClick={onSelectCMYK}
        disabled={switchingToCMYK}
        aria-busy={switchingToCMYK || undefined}
      >
        {switchingToCMYK && <IconLoading className={cn(styles.loader, 'cy-color-space-toggle-loading')} />}
        CMYK
      </button>
    </div>
  );
}

export default React.memo(ColorSpaceToggle);
